import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Email,
  Lock,
  Phone,
  Group,
  Person,
  PasswordRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { requestFCMToken } from "../../services/firebaseConfig";
import { toast } from 'react-toastify';

const SignUpPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [fcmToken, setFcmToken] = useState("");

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.fullName = "Full Name is required.";
    else if (formData.name.length < 2)
      newErrors.fullName = "At least 2 characters.";

    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email address.";

    if (!formData.phone.trim()) newErrors.phone = "Phone number is required.";
    else if (!/^\d+$/.test(formData.phone))
      newErrors.phone = "Only numbers allowed.";

    if (!formData.password) newErrors.password = "Password is required.";
    else if (formData.password.length < 6)
      newErrors.password = "Minimum 6 characters.";

    if (formData.confirmPassword !== formData.password)
      newErrors.confirmPassword = "Passwords do not match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const fetchFCMToken = async () => {
      try {
        const token = await requestFCMToken();
        console.log(token);
        setFcmToken(token);
      } catch (error) {
        console.error("Error getting FCM token : ", error);
      }
    };
    fetchFCMToken();
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    console.log("12345");
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!validate()) return;
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      console.log("12345");
      
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/signup`,
        {
          username: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
          fcmToken: fcmToken,
        }
      );
      console.log(res);
      if (res.status == 200) {
        toast.success("Sign-up successful! Pending approval.");
        toast.success("Redirecting...");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error(res.error);
      }
    } catch (err) {
      toast.error(err.response?.data?.error);
      setError(err.response?.data?.error || "Registration failed.");
    }
  };

  return (
    <Box>
      <Grid container rowSpacing={1} height="100vh">
        <Grid
          size={5}
          bgcolor="#0d1b2a"
          color="#cbd5e1"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Box textAlign="center">
            <img
              src="/assets/icons/main-logo-blue.png"
              alt="Logo"
              style={{ width: 100, marginBottom: 50 }}
            />
            <Typography variant="h3" gutterBottom style={{ margin: "20px" }}>
              WELCOME TO
            </Typography>
            <Typography
              variant="h6"
              sx={{ opacity: 0.7 }}
              style={{ margin: "20px" }}
            >
              Sign in to the Administration Panel to use services.
            </Typography>

            <Box sx={{ mt: 4 }}>
              <Typography variant="body2">عربي | English</Typography>
            </Box>
          </Box>
        </Grid>

        {/* Right Panel (Changed for Sign Up) */}
        <Grid
          size={7}
          bgcolor="#12233a"
          color="#cbd5e1"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Container maxWidth="sm">
            <Typography
              variant="h4"
              align="center"
              gutterBottom
              sx={{ color: "#cbd5e1" }}
            >
              SIGN UP
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                margin="normal"
                fullWidth
                label="Username"
                name="name"
                value={formData.name}
                error={!!errors.fullName}
                helperText={errors.fullName}
                onChange={handleChange}
                InputProps={{
                  style: { color: "#cbd5e1" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" sx={{ color: "#90a4ae" }}>
                        <Person />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "#90a4ae" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
              />
              <TextField
                margin="normal"
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                error={!!errors.email}
                helperText={errors.email}
                onChange={handleChange}
                InputProps={{
                  style: { color: "#cbd5e1" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" sx={{ color: "#90a4ae" }}>
                        <Email />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "#90a4ae" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
              />
              <TextField
                margin="normal"
                fullWidth
                label="Phone Number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={!!errors.phone}
                helperText={errors.phone}
                InputProps={{
                  style: { color: "#cbd5e1" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" sx={{ color: "#90a4ae" }}>
                        <Phone />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "#90a4ae" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
              />
              <TextField
                margin="normal"
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                error={!!errors.password}
                helperText={errors.password}
                onChange={handleChange}
                InputProps={{
                  style: { color: "#cbd5e1" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ color: "#90a4ae" }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{ style: { color: "#90a4ae" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
              />
              <TextField
                margin="normal"
                fullWidth
                label="Confirm Password"
                name="confirmPassword"
                type={showPassword ? "text" : "password"}
                value={formData.confirmPassword}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                onChange={handleChange}
                InputProps={{ style: { color: "#cbd5e1" } }}
                InputLabelProps={{ style: { color: "#90a4ae" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#90a4ae", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#00b4d8", // Border color on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00b4d8", // Border color when focused
                    },
                  },
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  p: 2,
                  backgroundColor: "#00b4d8",
                  "&:hover": { backgroundColor: "#0096c7" },
                }}
              >
                <Typography variant="h6">SIGN UP</Typography>
              </Button>

              <Divider sx={{ my: 2, borderColor: "#264653" }} />

              <Box textAlign="center" sx={{ color: "#90e0ef" }}>
                <Button
                  href="/login"
                  sx={{ color: "#90e0ef", textTransform: "none" }}
                >
                  Already have an account? Login
                </Button>
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SignUpPage;
